import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {


  // menu: any[] = [
  //   {
  //     titulo: 'Catalogos',
  //     icono: 'mdi mdi-gauge',
  //     submenu: [
     
  //       { titulo: 'Planteles', url: 'listadeplanteles', mostrar: true, icono: 'fa-school-flag' },
  //       { titulo: 'Empleados', url: 'listaderesguardante', mostrar: true, icono: 'fa-user' },

      
  //     ]
  //   },
  // ];
  menu2: any[] = [
    {
      titulo: 'Departamento de Recursos Humanos',
      icono: 'mdi mdi-gauge',
      submenu: [
        { titulo: 'Registro de facturas becas', url: 'listadebecas', mostrar: true, icono: 'fa-file-invoice-dollar' },
        { titulo: 'Registro de facturas lentes', url: 'listadelentes', mostrar: true, icono: 'fa-file-invoice-dollar' },
        { titulo: 'Registro de facturas aparatos ortopedicos', url: 'listadeaparatos', mostrar: true, icono: 'fa-file-invoice-dollar' },

      ]   
    },
  ];

  menu3: any[] = [
    {
      titulo: 'Departamento de Recursos Financieros',
      icono: 'mdi mdi-gauge',
      submenu: [
        { titulo: 'Facturas de Recursos Financieros', url: 'listaxmlfinancieros', mostrar: true, icono: 'fa-file-invoice-dollar' },
        { titulo: 'Reportes de DIOT', url: 'reportesdiot', mostrar: true, icono: 'fa-file-contract' },

      ]
    },
  ];



menu4: any[] = [
    {
          titulo: 'Usuarios',
          icono: 'mdi mdi-gauge',
          submenu: [
            
            { titulo: 'Agregar Usuario', url: 'registro/nuevousuario',mostrar:true, icono: 'fa-user-plus' },
            { titulo: 'Cambiar Contraseña', url: 'cambio/contrasena',mostrar:true, icono: 'fa-user-pen'},

            
          ]
        },
  ];

 

 menu6: any[] = [
    {
      titulo: 'Departamento de Contabilidad',
      icono: 'mdi mdi-gauge',
      submenu: [
        { titulo: 'Pólizas', url: 'listaxmlcontabilidadRH', mostrar: true, icono: 'fa-file-invoice-dollar' },
        { titulo: 'Reportes de Pólizas', url: 'reportes', mostrar: true, icono: 'fa-file-contract' },

      ]
    },
  ];

  menu7: any[] = [
    {
      titulo: 'Departamento Recursos Materiales',
      icono: 'mdi mdi-gauge',
      submenu: [
        { titulo: 'Facturas de Recursos Materiales', url: 'listaxmlmateriales', mostrar: true, icono: 'fa-file-invoice-dollar' },
   
      ]
    },
  ];



}